import { dmaCalculationFailureDtoSchema, DmaCalculationFailure } from "@fonterra/dma-api-schema";
export { DmaCalculationFailure as NpdCalculationFailure };
export const npdCalculationFailureDtoSchema = dmaCalculationFailureDtoSchema;
